export default class CreateOrUpdatePathResult {

    Id: number;

    constructor(id: number) {
        this.Id = id;
    }
}
